import Loader from "components/Common/Loader"
import Modal from "components/Common/Modal/Modal"
import PropTypes from "prop-types"
import { useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom/cjs/react-router-dom.min"
import { updateOrder } from "store/actions"

export const ModalInternalCustomerComments = ({
  t,
  orderInfo,
  setModalInternalCustomerCommentIsOpen,
  isOpen,
  modalType,
  updateOrder,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [internalOrderCustomerNumber, setInternalOrderCustomerNumber] = useState(
    orderInfo.customerOrderNumber || ""
  );
  const [internalOrderCustomerComment, setInternalOrderCustomerComment] = useState(
    orderInfo.customerComment || ""
  );

  const handleSave = async () => {
    const hasChanged =
      (modalType === "internalOrderComment" &&
        internalOrderCustomerComment !== (orderInfo.customerComment || "")) ||
      (modalType === "internalOrderNumber" &&
        internalOrderCustomerNumber !== (orderInfo.customerOrderNumber || ""));

    if (!hasChanged) {
      setModalInternalCustomerCommentIsOpen(false);
      return;
    }
    setIsLoading(true);
    try {
      await updateOrder({
        data: {
          order: {
            id: orderInfo.id,
            customerComment:
              modalType === "internalOrderComment"
                ? internalOrderCustomerComment
                : orderInfo.customerComment,
            customerOrderNumber:
              modalType === "internalOrderNumber"
                ? internalOrderCustomerNumber
                : orderInfo.customerOrderNumber,
          },
        },
      });
      setModalInternalCustomerCommentIsOpen(false);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Modal
        title={
          modalType === "internalOrderComment"
            ? t("customer_comment_title", { ns: "naming" })
            : t("customer_internal_order_number_title", { ns: "naming" })
        }
        isOpen={isOpen}
        closeModal={() => setModalInternalCustomerCommentIsOpen(false)}
        className="modal-dialog-centered"
        body={
          <div className="m-2 d-flex flex-row align-items-center">
            {modalType === "internalOrderComment" ? (
              <>
                <div style={{}}>
                  {t("customer_comment_label", { ns: "naming" })}:
                </div>
                <input
                  id="customComment"
                  className="form-control flex-1"
                  type="text"
                  value={internalOrderCustomerComment}
                  onChange={(e) =>
                    setInternalOrderCustomerComment(e.target.value)
                  }
                />
              </>
            ) : (
              <>
                <div className="w-auto" style={{ marginRight: "15px" }}>
                  {t("customer_internal_order_number_label", { ns: "naming" })}:
                </div>
                <input
                  id="customInvoiceNumber"
                  className="form-control w-auto"
                  type="text"
                  value={internalOrderCustomerNumber}
                  onChange={(e) => setInternalOrderCustomerNumber(e.target.value)}
                />
              </>
            )}
          </div>
        }
        buttons={[
          <button
            type="button"
            key="btnInvoice"
            className="btn btn-primary"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader className="mx-auto" />
            ) : (
              t("save", { ns: "naming" })
            )}
          </button>,
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

ModalInternalCustomerComments.propTypes = {
  t: PropTypes.func,
  orderInfo: PropTypes.object,
  setIsOpenDeliveryNoteModal: PropTypes.func,
  updateOrder: PropTypes.func,
  isOpen: PropTypes.bool,
  modalType: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, { updateOrder })(
    withTranslation()(ModalInternalCustomerComments)
  )
);
